import { dataChevronLeftCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronLeftCircle = /*#__PURE__*/createIcon(dataChevronLeftCircle)
export default IconChevronLeftCircle
